import { AlertColor } from '@mui/material';
import { createSlice } from '@reduxjs/toolkit';

interface State {
  isLoading: boolean;
  isShowToast: boolean;
  toastContent: {
    status?: AlertColor;
    code?: number;
    message?: string;
    description?: {
      code?: number;
      message?: string;
    };
  };
}

const initialState: State = {
  isLoading: false,
  isShowToast: false,
  toastContent: {},
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state: State, action) => {
      if (state.isLoading != action.payload) {
        state.isLoading = action.payload;
      }
    },
    showToast: (state: State, action) => {
      state.isShowToast = true;
      state.toastContent = action.payload;
    },
    closeToast: (state: State) => {
      state.isShowToast = false;
    },
  },
});

export const { showToast, setLoading, closeToast } = commonSlice.actions;
export default commonSlice.reducer;
